import React from 'react';
import { Image } from 'antd';

import logoKothe from '../../assets/img/logo-kothe.png';

import { Container, Box } from './styles';
import Spin from '../Spin';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

const ContainerBox: React.FC<any> = ({ children, width, maxwidth }) => {
  const loginLoading = useSelector((state: ApplicationState) => state.auth.loginLoading);
  return (
    <Container>
      {loginLoading ? (
        <Spin color="#FFF" />
      ) : (
        <Box width={width} maxwidth={maxwidth}>
          <Image preview={false} alt="Kothe" src={logoKothe} />
          {children}
        </Box>
      )}
    </Container>
  );
};

export default ContainerBox;
